import React,{Component} from "react";
import PropTypes from "prop-types";
import {grey} from "@mui/material/colors";
import RadioGroup from "@mui/material/RadioGroup";
import Radio from "@mui/material/Radio";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import FormControlLabel from "@mui/material/FormControlLabel";
import Divider from "@mui/material/Divider";
import { Box } from "@mui/material";

const s:any = {
  root: {
    color: grey[600],
    "&$checked": {
      color: grey[500]
    }
  },
  checked: {}
};

// usage:
// const steps = ["1hr", "3hrs", "1day", "3days"];
// <FChoice id="exp" label="Expire" values={steps} value="1hr" onChange={this.handleChange}/>,

class FChoice extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props:any) {
    super(props);
    const values = Array.isArray(props.values) && props.values.length > 0 ? props.values : [1, 0];
    this.state = {
      values,
      cur: props.value === undefined || props.value === null ? values[0] : props.value,
    };
  }

  handleChange = (event:any) => {
    const { onChange } = this.props;
    const value = event.target.value;
    this.setState({ cur: value });
    if (typeof onChange === 'function') onChange(value);
  };

  render() {
    const { id, label, value, divider, classes } = this.props;
    const { cur, values } = this.state;
    if(value) console.log('');

    return (
      <Box>
      <FormControl variant="outlined" fullWidth={true}> {/** id={id} **/}
        <FormLabel>
          {label}
        </FormLabel>
        <RadioGroup
          aria-label={label}
          id={id}
          name={id}
          value={cur}
          onChange={this.handleChange}
          row
        >
          {values.map((item:any, index:number) => (
            <FormControlLabel
              key={index}
              value={item}
              control={
                <Radio classes={{root:classes?.root}}/>
              }
              label={item}
              labelPlacement="bottom"
            />
          ))}
        </RadioGroup>
      </FormControl>
      {divider && <Divider />}
      </Box>
    );
  }
}

// FChoice.propTypes = {
//   //classes: PropTypes.object.isRequired,
//   //values: PropTypes.arrayOf("string").isRequired,
//   //id: PropTypes.string.isRequired,
//   //label: PropTypes.string.isRequired,
// };

export default FChoice;
